import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ss1 from "../assets/images/ss1.png";
import ss2 from "../assets/images/ss2.png";
import ss3 from "../assets/images/ss3.png";
import ss4 from "../assets/images/ss4.png";
import ss5 from "../assets/images/ss5.png";
import ss6 from "../assets/images/ss6.png";
import ss7 from "../assets/images/ss7.png";
import ss8 from "../assets/images/ss8.png";

// Custom Arrows
const PrevArrow = ({ className, onClick }) => {
  return (
    <div
      className={`${className} absolute top-1/2 -left-2 transform -translate-y-1/2 bg-black text-white rounded-full p-2 cursor-pointer z-10`}
      onClick={onClick}
    >
      <i className="fas fa-chevron-left text-sm"></i>
    </div>
  );
};

const NextArrow = ({ className, onClick }) => {
  return (
    <div
      className={`${className} absolute top-1/2 -right-2 transform -translate-y-1/2 bg-black text-white rounded-full p-2 cursor-pointer z-10`}
      onClick={onClick}
    >
      <i className="fas fa-chevron-right text-sm"></i>
    </div>
  );
};

const Screenshot = () => {
  const screenshots = [ss1, ss2, ss3, ss4, ss5, ss6, ss7, ss8];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      className="px-8 lg:px-32 xl:px-52 py-8"
      style={{
        background: "linear-gradient(180deg, #eafaf1 0%, #ffffff 100%)",
      }}
    >
      <p className="font-bold text-Black text-3xl pt-0">Screenshots</p>
      <div className="container mx-auto px-4 py-0 mt-10">
        <Slider {...sliderSettings}>
          {screenshots.map((screenshot, index) => (
            <div key={index} className="p-2">
              <img
                src={screenshot}
                alt={`Screenshot ${index + 1}`}
                className="w-full h-auto object-cover rounded-lg focus-visible:outline-none"
              />
            </div>
          ))}
        </Slider>
        <style>
          {`
          .slick-prev:before, .slick-next:before {
            color: black; /* Arrows in black */
            font-size: 30px;
          }
          .slick-prev:before {
            margin-left: -5px;
          }
          .slick-dots li button:before {
            color: black; /* Dots background color black */
            opacity: 1;
            transition: color 0.3s ease-in-out; /* Smooth transition for hover */
          }
          .slick-dots li.slick-active button:before {
            color: gray; /* Active dot color white */
          }
          .slick-dots {
            display: flex !important;
            justify-content: center;
            white-space: nowrap; /* Prevent line breaks */
            overflow-x: hidden; /* Prevent horizontal scrolling of dots */
            padding: 0; /* Remove extra padding */
          }
        `}
        </style>
      </div>
    </div>
  );
};

export default Screenshot;
